import * as React from 'react';
import customSolarIconWrapper from '../../../custom-icons';

// Placed on the shared 240x240 doodle frame: stack a body, eyes, mouth and accessory to compose a doodle
const DoodleMouthBouche10 = customSolarIconWrapper(<g transform="translate(108.5 159)">
	<rect x="0.745117" y="-0.646606" width="22.217" height="10" rx="5" transform="rotate(8 0.745117 -0.646606)" fill="#202020" />
</g>, { viewBox: '0 0 240 240' });

export default DoodleMouthBouche10;
